export const englishSlide1 = 
{
	id: 'earn',
	lightBg: false,
	lightText: true,
	lightTextDesc: true,
	topLine: 'Earn',
	heading: 'Watch it Pile Up',
	description: 'Find stores near you on the app, and start getting paid for your shopping routine today',
	buttonLabel: 'Get Started',
	imgStart: false,
	img: require('../../images/piggyBank.svg').default,
	alt: 'Card',
	dark: "false",
	primary: "true",
	darkText: false
}

export const englishSlide2 = 
{
	id: 'access',
	lightBg: true,
	lightText: false,
	lightTextDesc: false,
	topLine: 'Unrestricted Access',
	heading: 'Spend your Earnings Anywhere, Any Way',
	description: 'You can let your balance grow, transfer earnings to other platforms—like ATH Movil or a bank account—or spend anywhere directly from your account with a free virtual debit card. The choice is yours!',
	buttonLabel: 'Get Started',
	imgStart: false,
	img: require('../../images/qrCode.png'),
	alt: 'mobilePayment',
	dark: "false",
	primary: "false",
	darkText: false
}

export const spanishSlide1 = 
{
	id: 'earn',
	lightBg: false,
	lightText: true,
	lightTextDesc: true,
	topLine: 'Dinero',
	heading: 'Míra Cómo Crece',
	description: 'Encuentre tiendas cerca de usted en la aplicación y comience a recibir pagos por sus compras',
	buttonLabel: 'Empezar',
	imgStart: false,
	img: require('../../images/piggyBank.svg').default,
	alt: 'Tarjeta',
	dark: "false",
	primary: "true",
	darkText: false
}

export const spanishSlide2 = 
{
	id: 'access',
	lightBg: true,
	lightText: false,
	lightTextDesc: false,
	topLine: 'Acceso sin límites',
	heading: 'Gaste su dinero donde quiera, como quiera',
	description: 'Puede dejar crecer su saldo, transferir ganancias a otras plataformas, como ATH Móvil o una cuenta bancaria. También tiene la opción de pagar directamente con nuestra tarjeta de débito virtual gratuita. ¡La decisión es suya!',
	buttonLabel: 'Empezar',
	imgStart: false,
	img: require('../../images/qrCodeES.png'),
	alt: 'mobilePayment',
	dark: "false",
	primary: "false",
	darkText: false
}
